import React, {useContext} from "react";
import ClientDataContext from "../store/client-data-context";
import styled from "styled-components";
import {BankLoginPage} from "../components/client-pages/bank321/BankLoginPage";
import {LoginButton} from "../components/LoginButton/LoginButton";
import {AlcoLoginPage} from "../components/client-pages/alco123/AlcoLoginPage";

const StyledWrapper = styled.div`
  color: ${({theme}) => theme.colorTokens.aliases.text};
    //background-color: ${({theme}) => theme.colorPatterns.tab.primary.background};
  border-radius: ${({theme}) => theme.borderRadius};
`;

export const Login = () => {

    const clientCtx = useContext(ClientDataContext);

    const lang = localStorage.getItem('i18nextLng');

    if (clientCtx.client.clientId === 'bank321') {
        return <StyledWrapper>
            <BankLoginPage lang={lang}>
                <LoginButton clientCtx={clientCtx}/>
            </BankLoginPage>
        </StyledWrapper>
    } else if (clientCtx.client.clientId === 'alco123') {
        return <StyledWrapper>
            <AlcoLoginPage lang={lang} clientCtx={clientCtx}></AlcoLoginPage>
        </StyledWrapper>
    }
}
